export default __webpack_public_path__ + "static/media/undraw_house-searching_g2b8.3c373bcb.svg";